// False during SSR and the first client render, then true. Use this for "only
// render after mount" instead of `useState(false)` + `useEffect(() =>
// setMounted(true), [])`, which trips react-hooks/set-state-in-effect.
// useSyncExternalStore's server/client snapshots avoid hydration mismatches.
//
// Usage: const hydrated = useHydrated(); if (!hydrated) return null;
import { useSyncExternalStore } from 'react';

// Nothing to subscribe to: the value never changes after mount.
const emptySubscribe = () => () => {};

export function useHydrated(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true, // client snapshot
    () => false // server snapshot
  );
}
